import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import {
  grey2,
  grey4,
  grey5,
  grey7,
} from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { font14 } from 'approot/shared/styles/typography.style';
import { LabelStyled } from 'approot/shared/styles/inputs.style';
import { FileDropperImageField } from 'lib/form/file-dropper/file-dropper-image.style';
import { FileDropper } from 'lib/form/file-dropper/file-dropper.style';

type ImagePickerContainerProps = {
  $ratio: number;
  $hideBorder?: boolean;
};
export const ImagePickerContainer = styled.div<ImagePickerContainerProps>`
  background-color: ${grey2};
  border-radius: ${rem(borderRadius8)};
  margin-bottom: ${rem(spacing8)};
  overflow: hidden;
  padding-top: ${({ $ratio }) => 100 * $ratio}%;
  position: relative;
  width: 100%;

  ${({ $hideBorder = false }) =>
    !$hideBorder &&
    `
    border: 1px solid ${grey5};
  `}

  ${FileDropperImageField}, ${FileDropper} {
    position: absolute;
    top: 0;
    bottom: 0;
  }
`;

export const ImagePickerDisabledOverlay = styled.div`
  background-color: rgba(255, 255, 255, 0.4);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  &:hover {
    cursor: not-allowed;
  }
`;

export const ImagePickerEditor = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const ImagePickerActions = styled.div`
  position: absolute;
  top: ${rem(spacing8)};
  right: ${rem(spacing8)};
  z-index: 1;
`;

export const ImagePickerHelpText = styled(LabelStyled)`
  ${font14}
  color: ${grey7};
`;

export const ImageOptionsDivider = styled.div`
  background-color: ${grey4};
  height: ${rem(40)};
  width: ${rem(1)};
`;
